import React, { FC } from 'react';

interface GithubIconProps {
  text: string | number;
}

export const GithubIcon: FC<GithubIconProps> = ({ text }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="90" height="24" fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.999 0C5.373 0 0 5.509 0 12.304 0 17.74 3.438 22.351 8.207 23.98c.6.113.819-.267.819-.594 0-.292-.01-1.066-.017-2.092-3.337.743-4.042-1.65-4.042-1.65-.545-1.421-1.332-1.8-1.332-1.8-1.09-.762.082-.747.082-.747 1.205.087 1.838 1.268 1.838 1.268 1.07 1.88 2.81 1.337 3.493 1.022.109-.795.419-1.337.762-1.644-2.665-.312-5.467-1.367-5.467-6.081 0-1.344.468-2.442 1.236-3.302-.124-.311-.536-1.562.118-3.256 0 0 1.007-.33 3.3 1.26A11.258 11.258 0 0 1 12 5.95a11.27 11.27 0 0 1 3.005.414c2.29-1.592 3.296-1.261 3.296-1.261.655 1.694.243 2.945.12 3.256.77.86 1.233 1.958 1.233 3.302 0 4.726-2.806 5.766-5.478 6.07.43.38.814 1.131.814 2.28 0 1.644-.015 2.97-.015 3.374 0 .33.217.712.825.592 4.765-1.63 8.2-6.238 8.2-11.673C24 5.51 18.627 0 11.999 0Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33 8.7 28 12l5 3.3V19a4 4 0 0 0 4 4h49a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H37a4 4 0 0 0-4 4v3.7ZM29.878 12 34 14.748V19a3 3 0 0 0 3 3h49a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H37a3 3 0 0 0-3 3v4.252L29.878 12Z"
      clipRule="evenodd"
      opacity="1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m42.765 10.728 1.144-3.708a.093.093 0 0 1 .094-.067.093.093 0 0 1 .088.067l1.144 3.708h3.716c.091 0 .13.115.058.17L46 13.202l1.147 3.718c.027.089-.075.16-.149.104L44 14.73l-2.997 2.293c-.074.056-.176-.015-.15-.104l1.148-3.718-3.01-2.302a.095.095 0 0 1 .058-.171h3.716Zm-1.869 2.827-2.483-1.9c-.795-.608-.365-1.88.636-1.88h3.014L43 6.738c.304-.984 1.696-.984 2 0l.937 3.037h3.014c1.002 0 1.431 1.272.636 1.88l-2.483 1.9.951 3.083c.3.975-.825 1.761-1.635 1.142L44 15.93l-2.42 1.85c-.81.62-1.936-.167-1.635-1.142l.951-3.083Z"
      clipRule="evenodd"
    />
    <text fill="currentColor" x="53" y="17">
      {text}
    </text>
  </svg>
);
